import { Button, Container, Grid, TextField } from "@mui/material";
import React from "react";
import axiosInstance from "../../../../axios";
import { roles } from "../../../sidenav/constant";
import { toast } from "react-toastify";
import dayjs from "dayjs";

const QuizDetails = ({
  quizDetails,
  quizId,
  handleDetailsChange,
  handleQuizDetailsReset,
  formType,
  setValue,
  role,
  levelPermission,
}) => {
  const handleSave = () => {
    setValue("2");
  };

  const handleUpdate = async (quizId) => {
    const { data } = await axiosInstance.patch(`/quiz/${quizId}`, quizDetails);
    console.log(data);
    if (data?.statusCode === 200) {
      toast.success(data?.message);
    } else {
      toast.error("Failed to Update Quiz");
    }
  };
  return (
    <>
      <div>
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "0.5rem", marginBottom: "2rem" }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              label="Quiz Name *"
              size="small"
              fullWidth
              value={quizDetails.quizName}
              onChange={(e) => handleDetailsChange("quizName", e.target.value)}
              disabled={role === roles.SUB_ADMIN && !levelPermission}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6}>
            <TextField
              size="small"
              label="Duration (in min)*"
              fullWidth
              value={quizDetails.duration}
              onChange={(e) => handleDetailsChange("duration", e.target.value)}
              disabled={role === roles.SUB_ADMIN && !levelPermission}
              onWheel={(event) => event.target.blur()}
              type="number"
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6}>
            <TextField
              type="date"
              size="small"
              helperText="Due Date*"
              fullWidth
              InputProps={{inputProps: { min: dayjs().format("YYYY-MM-DD")} }}
              value={quizDetails.dueDate}
              onChange={(e) => handleDetailsChange("dueDate", e.target.value)}
              disabled={role === roles.SUB_ADMIN && !levelPermission}
            />
          </Grid>
        </Grid>
        {(role === "Admin" ||
          (role === roles.SUB_ADMIN && levelPermission)) && (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingBottom: "2rem",
            }}
          >
            <Button
              style={{
                textTransform: "none",
                color: "black",
                fontWeight: "bold",
              }}
              onClick={handleQuizDetailsReset}
            >
              Discard
            </Button>
            <Button
              style={{ textTransform: "none", marginLeft: "1rem" }}
              //   onClick={() => handlePlanAdd(selectedPlan)}
              disabled={
                quizDetails.quizName === "" ||
                quizDetails.dueDate === "" ||
                quizDetails.duration === null || quizDetails.duration === 0
              }
              onClick={() =>
                formType === "edit" ? handleUpdate(quizId) : handleSave()
              }
              variant="contained"
            >
              {formType === "edit" ? "Update Quiz Details" : "Save & Next"}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default QuizDetails;
